import React, { forwardRef, useState } from "react";
import { Checkbox, FormControlLabel, Grid } from "@mui/material";
import { Avatar } from "@material-ui/core";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import { FaFilePdf } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import { getDocumentByFileStoreId } from "@egovernments/digit-ui-libraries/src/utils/fileType";
import { InfoBox, SummaryCard } from "../../../components/StyledComponent";
import useDepartmentSelector from "../../../../TCPForms/hooks/useDepartmentSelector";
import { urlImg } from "../../../components/data";

const MapSubmissionSummary = forwardRef(({ formData, ref, handleDeclarationChange, declarationChecked, showDeclaration = false }) => {
  const [, applicationFlow] = useDepartmentSelector();
  const { t } = useTranslation();
  const [, setIsPreviewLoading] = useState(false);
  const descriptionOfLand = formData?.descriptionOfLand;
  const plotInfo = formData?.plotInfo;
  const structuralInfo = formData?.structuralInfo;
  const developerInfo = formData?.developerInfo;
  const ownerInfo = formData?.landInfo?.owners;
  const professionalInfo = formData?.professionaldetails;
  const feeDetail = formData?.taxHeadEstimates?.[0];
  const paymentHead = formData?.taxHeadEstimates?.[0]?.paymentHeads;
  const documents = formData?.documents;
  const bankInfo = formData?.landInfo?.bankdetails;
  const authorization = documents?.filter((doc) => ["authorization Letter"].includes(doc.documentType))?.[0]?.fileStoreId;
  const filteredDocuments = documents?.filter((doc) => !/^(signature|applicantPhoto)(\[\d+\])?$/.test(doc.documentType));
  const nameOfDepartment = applicationFlow == "DA" ? "DEVELOPMENT AUTHORITY" : "AWAS EVAM VIKAS PARISHAD";
  const edcrData = Digit.SessionStorage.get("EDCR_CREATE")?.[0];
  const watchProposalType = formData?.proposalType;
  const watchisSpecialProject = formData?.isSpecialProject;
  const watchTypeOfProject = formData?.typeOfProject;
  const watchPlotSubdivided = formData?.plotSubdivided;
  const watchNeedComp = formData?.needCompounding;
  const watchplotLeaseHold = formData?.plotLeaseHold;
  const watchisRevised = formData?.isRevised;
  const watchNoOfPLots = formData?.noOfPlots;
  const watchisApprovedLayout = formData?.isApprovedLayout;
  const watchisSetbackRequired = formData?.isSetbackRequired;
  const watchProjectType = formData?.projectType;
  const watchPlanOn = formData?.planOn;
  const watchNatureOfConstruction = formData?.constructionType;
  const watchbuildingClassification = formData?.buildingClassification;
  return (
    <div
      style={{
        backgroundColor: "#ffffff",
      }}
      ref={ref}
    >
      <div style={{ display: "flex", padding: "5px"}}>
        <div style={{ background: "white", borderRadius: "50%" }}>
          <img width="60" height="30" src={urlImg} alt="Uttar-Pradesh-Logo" />
        </div>
        <div style={{ color: "#1f4a7c" }}>
          <p style={{ marginLeft: "12px", fontSize: "1.25rem", fontWeight: "600", fontFamily: '"Calibri", sans-serif' }}>
            Lucknow Development Authority
          </p>
          <p style={{ marginLeft: "12px", fontFamily: '"Calibri", sans-serif', fontWeight: "500" }}>Government of Uttar Pradesh</p>
        </div>
      </div>

      <div className="groupContainer" style={{ width: "100%", marginTop: "1rem" }}>
        {/* General Information */}

        {/* <SummaryCard className="formContainer">
                    <div className="formHeaderContainer">
                        <h2 className="formHeading">{t('General Information')}</h2>
                    </div>
                    <div className="formInputContainer" style={{ display: "flex", justifyContent: "center" }}>
                        <div style={{ width: "100%" }}>
                            <table style={{ width: "100%", borderCollapse: "collapse" }}>
                                <tbody>
                                    {formData?.tod?.orientDevelopment && (
                                        <tr>
                                            <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                                <b>Is Proposal Transit Oriented Development (TOD)</b>
                                            </td>
                                            <td>
                                                {formData?.tod?.orientDevelopment?.charAt(0).toUpperCase() + formData?.tod?.orientDevelopment?.slice(1)}
                                            </td>
                                        </tr>
                                    )}
                                    {formData?.tod?.convertedLandUseinTOD && (
                                        <tr>
                                            <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                                <b>Converted Land Use in TOD:</b>
                                            </td>
                                            <td style={{ width: "50%", padding: "8px" }}>{formData?.tod?.convertedLandUseinTOD?.charAt(0).toUpperCase() + formData?.tod?.convertedLandUseinTOD?.slice(1)}</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </SummaryCard> */}

        <SummaryCard className="formContainer">
          <div className="formHeaderContainer">
            <h2 className="formHeading">General Information</h2>
          </div>
          <div className="formInputContainer" style={{ display: "flex", justifyContent: "center" }}>
            <div style={{ width: "100%" }}>
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <tbody>
                  {formData?.prevSanctionNo && (
                    <tr>
                      <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                        <b>Prev Sanction No:</b>
                      </td>
                      <td style={{ width: "50%", padding: "8px" }}>{formData?.prevSanctionNo}</td>
                    </tr>
                  )}
                  {formData?.prevSanctionDate && (
                    <tr>
                      <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                        <b>Prev Sanction Date:</b>
                      </td>
                      <td style={{ width: "50%", padding: "8px" }}>{formData?.prevSanctionDate}</td>
                    </tr>
                  )}
                  {formData?.currValidityDate && (
                    <tr>
                      <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                        <b>Current Validity Date:</b>
                      </td>
                      <td style={{ width: "50%", padding: "8px" }}>{formData?.currValidityDate}</td>
                    </tr>
                  )}
                  {formData?.land_Id && (
                    <tr>
                      <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                        <b>FASTPAS ID:</b>
                      </td>
                      <td style={{ width: "50%", padding: "8px" }}>{formData?.land_Id}</td>
                    </tr>
                  )}
                  {formData?.zoneType && (
                    <tr>
                      <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                        <b>Land Use:</b>
                      </td>
                      <td style={{ width: "50%", padding: "8px" }}>{formData?.zoneType}</td>
                    </tr>
                  )}
                  {formData?.subZoneType && (
                    <tr>
                      <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                        <b>Land Sub Use:</b>
                      </td>
                      <td style={{ width: "50%", padding: "8px" }}>{formData?.subZoneType}</td>
                    </tr>
                  )}
                  {formData?.primaryUse && (
                    <tr>
                      <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                        <b>Primary Use of Proposed Activity:</b>
                      </td>
                      <td style={{ width: "50%", padding: "8px" }}>{formData?.primaryUse}</td>
                    </tr>
                  )}
                  {edcrData?.activityProposed && (
                    <tr>
                      <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                        <b>Activity proposed:</b>
                      </td>
                      <td style={{ width: "50%", padding: "8px" }}>{edcrData?.activityProposed}</td>
                    </tr>
                  )}
                  {formData?.planOn && (
                    <tr>
                      <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                        <b>Proposed Site:</b>
                      </td>
                      <td style={{ width: "50%", padding: "8px" }}>{formData?.planOn}</td>
                    </tr>
                  )}
                  {watchPlanOn === "Others" && formData?.otherSchemeName && (
                    <tr>
                      <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                        <b>Other Proposed Site:</b>
                      </td>
                      <td style={{ width: "50%", padding: "8px" }}>{formData?.otherSchemeName}</td>
                    </tr>
                  )}
                  {formData?.sanctionNumber && (
                    <tr>
                      <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                        <b>Layout Sanction No:</b>
                      </td>
                      <td style={{ width: "50%", padding: "8px" }}>{formData?.sanctionNumber}</td>
                    </tr>
                  )}
                  {formData?.sanctionDate && (
                    <tr>
                      <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                        <b>Layout Sanction Date:</b>
                      </td>
                      <td style={{ width: "50%", padding: "8px" }}>{formData?.sanctionDate}</td>
                    </tr>
                  )}
                  {formData?.isMetroCity && (
                    <tr>
                      <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                        <b>Is this Site falls in Metro City:</b>
                      </td>
                      <td style={{ width: "50%", padding: "8px" }}>{formData?.isMetroCity}</td>
                    </tr>
                  )}
                  {watchPlanOn === "Others" && formData?.constructionType && (
                    <tr>
                      <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                        <b>Development Area:</b>
                      </td>
                      <td style={{ width: "50%", padding: "8px" }}>{formData?.constructionType}</td>
                    </tr>
                  )}
                  {watchNatureOfConstruction !== "New" && formData?.natureOfConstruction && (
                    <tr>
                      <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                        <b>Nature of Construction /Case Type:</b>
                      </td>
                      <td style={{ width: "50%", padding: "8px" }}>{formData?.natureOfConstruction}</td>
                    </tr>
                  )}
                  {watchNatureOfConstruction !== "New" && formData?.prevFileNo && (
                    <tr>
                      <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                        <b>Prev File No:</b>
                      </td>
                      <td style={{ width: "50%", padding: "8px" }}>{formData?.prevFileNo}</td>
                    </tr>
                  )}
                  {formData?.schemeName && (
                    <tr>
                      <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                        <b>Scheme Name:</b>
                      </td>
                      <td style={{ width: "50%", padding: "8px" }}>{formData?.schemeName}</td>
                    </tr>
                  )}
                  {formData?.tehsil && (
                    <tr>
                      <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                        <b>Tehsil:</b>
                      </td>
                      <td style={{ width: "50%", padding: "8px" }}>{formData?.tehsil}</td>
                    </tr>
                  )}
                  {formData?.revenueVillage && (
                    <tr>
                      <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                        <b>Revenue Village/College Name:</b>
                      </td>
                      <td style={{ width: "50%", padding: "8px" }}>{formData?.revenueVillage}</td>
                    </tr>
                  )}
                  {formData?.landMark && (
                    <tr>
                      <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                        <b>Land Mark:</b>
                      </td>
                      <td style={{ width: "50%", padding: "8px" }}>{formData?.landMark}</td>
                    </tr>
                  )}
                  {formData?.sectorNo && (
                    <tr>
                      <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                        <b>Sector/Pocket No.:</b>
                      </td>
                      <td style={{ width: "50%", padding: "8px" }}>{formData?.sectorNo}</td>
                    </tr>
                  )}
                  {formData?.khasraNo && (
                    <tr>
                      <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                        <b>Khasra No:</b>
                      </td>
                      <td style={{ width: "50%", padding: "8px" }}>{formData?.khasraNo}</td>
                    </tr>
                  )}
                  {formData?.proposalType && (
                    <tr>
                      <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                        <b>Standard Type Design:</b>
                      </td>
                      <td style={{ width: "50%", padding: "8px" }}>{formData?.proposalType}</td>
                    </tr>
                  )}
                  {descriptionOfLand?.plotNo && (
                    <tr>
                      <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                        <b>Plot No:</b>
                      </td>
                      <td style={{ width: "50%", padding: "8px" }}>{descriptionOfLand?.plotNo}</td>
                    </tr>
                  )}
                  {watchProposalType === "yes" && formData?.sanctionDate && (
                    <tr>
                      <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                        <b>Sanction date Of layout:</b>
                      </td>
                      <td style={{ width: "50%", padding: "8px" }}>{formData?.sanctionDate}</td>
                    </tr>
                  )}
                  {watchProposalType === "yes" && formData?.sanctionNumber && (
                    <tr>
                      <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                        <b>Sanction number of layout:</b>
                      </td>
                      <td style={{ width: "50%", padding: "8px" }}>{formData?.sanctionNumber}</td>
                    </tr>
                  )}
                  {watchProposalType === "yes" && formData?.noOfPlots && (
                    <tr>
                      <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                        <b>No Of Plots:</b>
                      </td>
                      <td style={{ width: "50%", padding: "8px" }}>{formData?.noOfPlots}</td>
                    </tr>
                  )}
                  {watchProposalType === "yes" && formData?.plotNumbers && (
                    <tr>
                      <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                        <b>Plots:</b>
                      </td>
                      <td style={{ width: "50%", padding: "8px" }}>{formData?.plotNumbers?.join(", ")}</td>
                    </tr>
                  )}
                  {formData?.buildingClassification && (
                    <tr>
                      <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                        <b>Project Type:</b>
                      </td>
                      <td style={{ width: "50%", padding: "8px" }}>{formData?.buildingClassification}</td>
                    </tr>
                  )}
                  {watchbuildingClassification === "Others" && formData?.otherbuildingClass && (
                    <tr>
                      <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                        <b>Other Project:</b>
                      </td>
                      <td style={{ width: "50%", padding: "8px" }}>{formData?.otherbuildingClass}</td>
                    </tr>
                  )}
                  {formData?.isSpecialProject && (
                    <tr>
                      <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                        <b>Special Project Type:</b>
                      </td>
                      <td style={{ width: "50%", padding: "8px" }}>{formData?.isSpecialProject}</td>
                    </tr>
                  )}
                  {formData?.communityParking && (
                    <tr>
                      <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                        <b>If Community Parking Provided:</b>
                      </td>
                      <td style={{ width: "50%", padding: "8px" }}>{formData?.communityParking}</td>
                    </tr>
                  )}
                  {watchisSpecialProject === "yes" && formData?.projectType && (
                    <tr>
                      <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                        <b>Special Condition Of Project:</b>
                      </td>
                      <td style={{ width: "50%", padding: "8px" }}>{formData?.projectType}</td>
                    </tr>
                  )}
                  {watchisSpecialProject === "Other" && formData?.otherProjectName && (
                    <tr>
                      <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                        <b>Other Project:</b>
                      </td>
                      <td style={{ width: "50%", padding: "8px" }}>{formData?.otherProjectName}</td>
                    </tr>
                  )}
                  {watchisSpecialProject === "yes" &&
                    (watchProjectType === "Building Design as per standard Drawing" ||
                      watchProjectType === "Standard condition as per Lease deed/freehold deed") &&
                    formData?.groundCoverage && (
                      <tr>
                        <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                          <b>Ground Coverage:</b>
                        </td>
                        <td style={{ width: "50%", padding: "8px" }}>{formData?.groundCoverage}</td>
                      </tr>
                    )}
                  {watchisSpecialProject === "yes" &&
                    (watchProjectType === "Building Design as per standard Drawing" ||
                      watchProjectType === "Standard condition as per Lease deed/freehold deed") &&
                    formData?.far && (
                      <tr>
                        <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                          <b>FAR:</b>
                        </td>
                        <td style={{ width: "50%", padding: "8px" }}>{formData?.far}</td>
                      </tr>
                    )}
                  {watchisSpecialProject === "yes" &&
                    (watchProjectType === "Building Design as per standard Drawing" ||
                      watchProjectType === "Standard condition as per Lease deed/freehold deed") &&
                    formData?.buildingHeight && (
                      <tr>
                        <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                          <b>Building Height:</b>
                        </td>
                        <td style={{ width: "50%", padding: "8px" }}>{formData?.buildingHeight}</td>
                      </tr>
                    )}
                  {watchisSpecialProject === "yes" &&
                    (watchProjectType === "Building Design as per standard Drawing" ||
                      watchProjectType === "Standard condition as per Lease deed/freehold deed") &&
                    formData?.setbackFronts && (
                      <tr>
                        <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                          <b>Front:</b>
                        </td>
                        <td style={{ width: "50%", padding: "8px" }}>{formData?.setbackFronts}</td>
                      </tr>
                    )}
                  {watchisSpecialProject === "yes" &&
                    (watchProjectType === "Building Design as per standard Drawing" ||
                      watchProjectType === "Standard condition as per Lease deed/freehold deed") &&
                    formData?.setbackRears && (
                      <tr>
                        <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                          <b>Rear:</b>
                        </td>
                        <td style={{ width: "50%", padding: "8px" }}>{formData?.setbackRears}</td>
                      </tr>
                    )}
                  {watchisSpecialProject === "yes" &&
                    (watchProjectType === "Building Design as per standard Drawing" ||
                      watchProjectType === "Standard condition as per Lease deed/freehold deed") &&
                    formData?.setbackSide1 && (
                      <tr>
                        <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                          <b>Side Setback- 1:</b>
                        </td>
                        <td style={{ width: "50%", padding: "8px" }}>{formData?.setbackSide1}</td>
                      </tr>
                    )}
                  {watchisSpecialProject === "yes" &&
                    (watchProjectType === "Building Design as per standard Drawing" ||
                      watchProjectType === "Standard condition as per Lease deed/freehold deed") &&
                    formData?.setbackSide2 && (
                      <tr>
                        <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                          <b>Side Setback - 2:</b>
                        </td>
                        <td style={{ width: "50%", padding: "8px" }}>{formData?.setbackSide2}</td>
                      </tr>
                    )}
                  {(watchPlanOn === "Self Certification of residential Plot Area upto 300 SqM on approved layouts" ||
                  watchPlanOn ==="Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm" && formData?.plotSubdivided) && (
                    <tr>
                      <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                        <b>Is Your Plot Sub-division:</b>
                      </td>
                      <td style={{ width: "50%", padding: "8px" }}>{formData?.plotSubdivided}</td>
                    </tr>
                  )}
                  {(watchPlanOn === "Self Certification of residential Plot Area upto 300 SqM on approved layouts"
                  || watchPlanOn ==="Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm")
                   &&
                    watchPlotSubdivided === "no" &&
                    formData?.needCompounding && (
                      <tr>
                        <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                          <b>Does existing building require any compounding ?:</b>
                        </td>
                        <td style={{ width: "50%", padding: "8px" }}>{formData?.needCompounding}</td>
                      </tr>
                    )}
                  {(watchPlanOn === "Self Certification of residential Plot Area upto 300 SqM on approved layouts"
                  || watchPlanOn ==="Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm"
                  ) &&
                    watchPlotSubdivided === "no" &&
                    watchNeedComp === "no" &&
                    formData?.plotLeaseHold && (
                      <tr>
                        <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                          <b>Is your plot Lease hold ?:</b>
                        </td>
                        <td style={{ width: "50%", padding: "8px" }}>{formData?.plotLeaseHold}</td>
                      </tr>
                    )}
                  {(watchPlanOn === "Self Certification of residential Plot Area upto 300 SqM on approved layouts"
                  || watchPlanOn ==="Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm"
                  ) &&
                    watchPlotSubdivided === "no" &&
                    watchplotLeaseHold === "yes" &&
                    edcrData?.leaseholdNOC && (
                      <tr>
                        <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                          <b>NOC for Lease hold :</b>
                        </td>
                        <td style={{ width: "50%", padding: "8px" }}>{edcrData?.leaseholdNOC}</td>
                      </tr>
                    )}
                  {watchisSetbackRequired === "yes" && (
                    <tr>
                      <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                        <b>Setback Front:</b>
                      </td>
                      <td style={{ width: "50%", padding: "8px" }}>{edcrData?.previousSetbackFront}</td>
                    </tr>
                  )}
                  {watchisSetbackRequired === "yes" && (
                    <tr>
                      <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                        <b>Setback Rear:</b>
                      </td>
                      <td style={{ width: "50%", padding: "8px" }}>{edcrData?.previousSetbackRear}</td>
                    </tr>
                  )}
                  {watchisSetbackRequired === "yes" && (
                    <tr>
                      <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                        <b>Setback Left:</b>
                      </td>
                      <td style={{ width: "50%", padding: "8px" }}>{edcrData?.previousSetbackSide1}</td>
                    </tr>
                  )}
                  {watchisSetbackRequired === "yes" && (
                    <tr>
                      <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                        <b>Setback Right:</b>
                      </td>
                      <td style={{ width: "50%", padding: "8px" }}>{edcrData?.previousSetbackSide2}</td>
                    </tr>
                  )}

                  {watchisSetbackRequired === "yes" && (
                    <tr>
                      <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                        <b>No. Of Plots:</b>
                      </td>
                      <td style={{ width: "50%", padding: "8px" }}>{edcrData?.noOfPlots}</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </SummaryCard>

        {/* Professional Information */}
        <SummaryCard className="formContainer">
          <div className="formHeaderContainer">
            <h2 className="formHeading">{t("Licensed Technical Person (LTP)")}</h2>
          </div>
          <div className="formInputContainer" style={{ display: "flex", justifyContent: "center" }}>
            <div style={{ width: "100%" }}>
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <tbody>
                  <tr>
                    <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                      <b>Consultant Category:</b>
                    </td>
                    <td style={{ width: "50%", padding: "8px" }}>{professionalInfo?.consultantCategory}</td>
                  </tr>

                  <tr>
                    <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                      <b>Name:</b>
                    </td>
                    <td style={{ width: "50%", padding: "8px" }}>{professionalInfo?.name}</td>
                  </tr>

                  <tr>
                    <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                      <b>Certificate No:</b>
                    </td>
                    <td style={{ width: "50%", padding: "8px" }}>{professionalInfo?.certificateNo}</td>
                  </tr>

                  <tr>
                    <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                      <b>Email Id:</b>
                    </td>
                    <td style={{ width: "50%", padding: "8px" }}>{professionalInfo?.emailId}</td>
                  </tr>

                  <tr>
                    <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                      <b>Mobile No:</b>
                    </td>
                    <td style={{ width: "50%", padding: "8px" }}>{professionalInfo?.mobileNumber}</td>
                  </tr>

                  <tr>
                    <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                      <b>Valid Upto:</b>
                    </td>
                    <td style={{ width: "50%", padding: "8px" }}>{professionalInfo?.validupto}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </SummaryCard>

        {/* Owner Information */}
        <SummaryCard className="formContainer">
          {ownerInfo?.map((item, index) => (
            <React.Fragment>
              <div className="formHeaderContainer">
                <h2 className="formHeading">{index > 0 ? "Addition Owner Information" : "Owner Information"}</h2>
              </div>
              <div className="formInputContainer" style={{ display: "flex", justifyContent: "center" }}>
                <div style={{ width: "100%" }}>
                  <div>
                    <div
                      key={index}
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        flexWrap: "wrap",
                        marginTop: "15px",
                        marginBottom: "15px",

                        paddingBottom: "15px",
                      }}
                    >
                      {/*  */}
                      <div style={{ flex: "1 1 calc(50% - 10px)", marginRight: "10px" }}>
                        <table style={{ width: "100%", borderCollapse: "collapse" }}>
                          <tbody>
                            <tr>
                              <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                <b>Name:</b>
                              </td>
                              <td style={{ width: "50%", padding: "8px" }}>{item?.name}</td>
                            </tr>

                            <tr>
                              <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                <b>Email Id:</b>
                              </td>
                              <td style={{ width: "50%", padding: "8px" }}>{item?.emailId}</td>
                            </tr>

                            <tr>
                              <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                <b>Mobile No:</b>
                              </td>
                              <td style={{ width: "50%", padding: "8px" }}>{item?.mobileNumber}</td>
                            </tr>

                            <tr>
                              <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                <b>Input On GST:</b>
                              </td>
                              <td style={{ width: "50%", padding: "8px" }}>
                                {item?.inputonGST === "yes" || item?.inputonGST?.value === "yes" ? "Yes" : item?.inputonGST === "no" || item?.inputonGST?.value === "no" ? "No" : item?.inputonGST || "N/A"}
                              </td>
                            </tr>

                            {(item?.inputonGST === "yes" || item?.inputonGST?.value === "yes") && (
                              <tr>
                                <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                  <b>GST No:</b>
                                </td>
                                <td style={{ width: "50%", padding: "8px" }}>{item?.gstNumber || "N/A"}</td>
                              </tr>
                            )}

                            <tr>
                              <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                <b>State:</b>
                              </td>
                              <td style={{ width: "50%", padding: "8px" }}>{item?.correspondenceAddress?.state}</td>
                            </tr>

                            <tr>
                              <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                <b>District:</b>
                              </td>
                              <td style={{ width: "50%", padding: "8px" }}>{item?.correspondenceAddress?.town}</td>
                            </tr>
                            <tr>
                              <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                <b>Address:</b>
                              </td>
                              <td style={{ width: "50%", padding: "8px" }}>{item?.correspondenceAddress?.address}</td>
                            </tr>
                            <tr>
                              <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                <b>Pin No:</b>
                              </td>
                              <td style={{ width: "50%", padding: "8px" }}>{item?.correspondenceAddress?.pinno}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      {item?.photo && (
                        <div
                          style={{
                            flex: "1 1 calc(50% - 10px)",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-around",
                            alignItems: "center",
                          }}
                        >
                          <div className="row" style={{ marginBottom: "10px" }}>
                            {item?.photo ? (
                              <img
                                style={{ width: "200px", height: "200px", objectFit: "cover" }}
                                src={item?.photo}
                                alt={"image"}
                                className="img-thumbnail"
                              />
                            ) : (
                              <Avatar style={{ width: "200px", height: "80px" }}>{item?.photo}</Avatar>
                            )}
                          </div>
                          {/* <div className="row" style={{ marginBottom: "10px" }}>
                                                        {item?.signature ? (
                                                            <img style={{ width: "200px", height: "80px" }} src={item?.signature} alt={"signature"} className="img-thumbnail" />
                                                        ) : (
                                                            <BorderColorIcon style={{ width: "70px", height: "25px" }}>{item?.signature}</BorderColorIcon>
                                                        )}
                                                    </div> */}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </React.Fragment>
          ))}
        </SummaryCard>

        {/* Developer Information */}
        {/* <SummaryCard className="formContainer">
                    <div className="formHeaderContainer">
                        <h2 className="formHeading">Develoer Information</h2>
                    </div>
                    <div className="formInputContainer" style={{ display: "flex", justifyContent: "center" }}>
                        <div style={{ width: "100%" }}>
                            <table style={{ width: "100%", borderCollapse: "collapse" }}>
                                <tbody>

                                    <tr>
                                        <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                            <b>Name:</b>
                                        </td>
                                        <td style={{ width: "50%", padding: "8px" }}>{developerInfo?.name}</td>
                                    </tr>


                                    <tr>
                                        <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                            <b>Mobile No:</b>
                                        </td>
                                        <td style={{ width: "50%", padding: "8px" }}>{developerInfo?.mobileNumber}</td>
                                    </tr>


                                    <tr>
                                        <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                            <b>License No:</b>
                                        </td>
                                        <td style={{ width: "50%", padding: "8px" }}>{developerInfo?.licenseNumber}</td>
                                    </tr>

                                    <tr>
                                        <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                            <b>Address:</b>
                                        </td>
                                        <td style={{ width: "50%", padding: "8px" }}>{developerInfo?.permanentAddress?.address}</td>
                                    </tr>

                                </tbody>
                            </table>
                        </div>
                    </div>
                </SummaryCard> */}

        {/* Structural Information */}

        {structuralInfo &&
          (structuralInfo.name || structuralInfo.validupto || structuralInfo.licenseNumber || structuralInfo.permanentAddress?.address) && (
            <SummaryCard className="formContainer">
              <div className="formHeaderContainer">
                <h2 className="formHeading">Structural Engineer Information</h2>
              </div>
              <div className="formInputContainer" style={{ display: "flex", justifyContent: "center" }}>
                <div style={{ width: "100%" }}>
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                          <b>Name:</b>
                        </td>
                        <td style={{ width: "50%", padding: "8px" }}>{structuralInfo?.name || "N/A"}</td>
                      </tr>

                      <tr>
                        <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                          <b>Valid Upto:</b>
                        </td>
                        <td style={{ width: "50%", padding: "8px" }}>{structuralInfo?.validupto || "N/A"}</td>
                      </tr>

                      <tr>
                        <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                          <b>License No:</b>
                        </td>
                        <td style={{ width: "50%", padding: "8px" }}>{structuralInfo?.licenseNumber || "N/A"}</td>
                      </tr>

                      <tr>
                        <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                          <b>Address:</b>
                        </td>
                        <td style={{ width: "50%", padding: "8px" }}>{structuralInfo?.permanentAddress?.address || "N/A"}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </SummaryCard>
          )}
        {/* PLot Information */}
        <SummaryCard className="formContainer">
          <div className="formHeaderContainer">
            <h2 className="formHeading">Plot Information</h2>
          </div>
          <div className="formInputContainer" style={{ display: "flex", justifyContent: "center" }}>
            <div style={{ width: "100%" }}>
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <tbody>
                  {/* 
                                    <tr>
                                        <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                            <b>Land Use Zone:</b>
                                        </td>
                                        <td style={{ width: "50%", padding: "8px" }}>{plotInfo?.zoneType}</td>
                                    </tr>


                                    <tr>
                                        <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                            <b>Land Sub Use Zone:</b>
                                        </td>
                                        <td style={{ width: "50%", padding: "8px" }}>{plotInfo?.subZoneType}</td>
                                    </tr>


                                    <tr>
                                        <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                            <b>Development Area:</b>
                                        </td>
                                        <td style={{ width: "50%", padding: "8px" }}>{plotInfo?.developmentArea}</td>
                                    </tr> */}

                  <tr>
                    <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                      <b>Plot Area:</b>
                    </td>
                    <td style={{ width: "50%", padding: "8px" }}>{formData?.descriptionOfLand?.landArea}</td>
                  </tr>

                  <tr>
                    <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                      <b>Built-up Area:</b>
                    </td>
                    <td style={{ width: "50%", padding: "8px" }}>{formData?.totalBuildUpArea}</td>
                  </tr>

                  {/* <tr>
                                        <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                            <b>Existing Built-up Area:</b>
                                        </td>
                                        <td style={{ width: "50%", padding: "8px" }}>{plotInfo?.exsistingbuiltupArea}</td>
                                    </tr> */}

                  <tr>
                    <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                      <b>Estimated Cost:</b>
                    </td>
                    <td style={{ width: "50%", padding: "8px" }}>{plotInfo?.estimatedCost}</td>
                  </tr>

                  {/* <tr>
                                        <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                            <b>Community Parking:</b>
                                        </td>
                                        <td style={{ width: "50%", padding: "8px" }}>{plotInfo?.communityParking}</td>
                                    </tr> */}

                  {/* <tr>
                                        <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                            <b>Additional FAR:</b>
                                        </td>
                                        <td style={{ width: "50%", padding: "8px" }}>{plotInfo?.isAdditionalFAR}</td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                            <b>Ground Coverage %:</b>
                                        </td>
                                        <td style={{ width: "50%", padding: "8px" }}>{plotInfo?.groundCoverage}</td>
                                    </tr> */}
                  {/* <tr>
                                        <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                            <b>Plot Use:</b>
                                        </td>
                                        <td style={{ width: "50%", padding: "8px" }}>{plotInfo?.plotType}</td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                            <b>Plot Sub Use:</b>
                                        </td>
                                        <td style={{ width: "50%", padding: "8px" }}>{plotInfo?.plotSubType}</td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                            <b>Sub Development Area:</b>
                                        </td>
                                        <td style={{ width: "50%", padding: "8px" }}>{plotInfo?.subdevelopmentType}</td>
                                    </tr> */}
                  {/* <tr>
                                        <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                            <b>Scheme Name:</b>
                                        </td>
                                        <td style={{ width: "50%", padding: "8px" }}>{plotInfo?.schemeName}</td>
                                    </tr> */}
                  {/* <tr>
                                        <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                            <b>Maximum Building Height:</b>
                                        </td>
                                        <td style={{ width: "50%", padding: "8px" }}>{plotInfo?.maxBuildingHeight}</td>
                                    </tr> */}

                  {formData?.edcrNumber && (
                    <tr>
                      <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                        <b>Plot area as per Drawing (Sq.Mt):</b>
                      </td>
                      <td style={{ width: "50%", padding: "8px" }}>{plotInfo?.plotArea}</td>
                    </tr>
                  )}
                  {/* <tr>
                                        <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                            <b>Critical Rate:</b>
                                        </td>
                                        <td style={{ width: "50%", padding: "8px" }}>{plotInfo?.criticalRate}</td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                            <b>Carpet Area:</b>
                                        </td>
                                        <td style={{ width: "50%", padding: "8px" }}>{plotInfo?.carpetArea}</td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                            <b>Groud Coverage Area:</b>
                                        </td>
                                        <td style={{ width: "50%", padding: "8px" }}>{plotInfo?.groundCoverageArea}</td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                            <b>Number of Stories including Ground Floor:</b>
                                        </td>
                                        <td style={{ width: "50%", padding: "8px" }}>{plotInfo?.noOfStories}</td>
                                    </tr> */}
                  {/* <tr>
                                        <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                            <b>Is this Approved Layout:</b>
                                        </td>
                                        <td style={{ width: "50%", padding: "8px" }}>{plotInfo?.approvedLayout}</td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                            <b>FAR:</b>
                                        </td>
                                        <td style={{ width: "50%", padding: "8px" }}>{plotInfo?.far}</td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                            <b>Is plot has special required value of Setback?:</b>
                                        </td>
                                        <td style={{ width: "50%", padding: "8px" }}>{plotInfo?.setback?.required}</td>
                                    </tr>

                                    <React.Fragment>
                                        <tr>
                                            <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                                <b>Setback (Front):</b>
                                            </td>
                                            <td style={{ width: "50%", padding: "8px" }}>{plotInfo?.setback?.front}</td>
                                        </tr>
                                        <tr>
                                            <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                                <b>Setback (Rear):</b>
                                            </td>
                                            <td style={{ width: "50%", padding: "8px" }}>{plotInfo?.setback?.rear}</td>
                                        </tr>

                                        <tr>
                                            <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                                <b>Setback (Left):</b>
                                            </td>
                                            <td style={{ width: "50%", padding: "8px" }}>{plotInfo?.setback?.side1}</td>
                                        </tr>

                                        <tr>
                                            <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                                <b>Setback (Right):</b>
                                            </td>
                                            <td style={{ width: "50%", padding: "8px" }}>{plotInfo?.setback?.side2}</td>
                                        </tr>

                                    </React.Fragment> */}
                </tbody>
              </table>
            </div>
          </div>
        </SummaryCard>

        {/* Location Information */}
        <SummaryCard className="formContainer">
          <div className="formHeaderContainer">
            <h2 className="formHeading">Location Information</h2>
          </div>
          <div className="formInputContainer" style={{ display: "flex", justifyContent: "center" }}>
            <div style={{ width: "100%" }}>
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <tbody>
                  <tr>
                    <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                      <b>Map Coordinates:</b>
                    </td>
                    <td style={{ width: "50%", padding: "8px" }}>
                      Latitude: {descriptionOfLand?.latitude}, Longitude: {descriptionOfLand?.longitude}
                    </td>
                  </tr>

                  {/* {descriptionOfLand?.googleMapLocation && (
                                            <tr>
                                                <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                                    <b>Map Location:</b>
                                                </td>
                                                <td style={{ width: "50%", padding: "8px" }}>{descriptionOfLand?.googleMapLocation}</td>
                                            </tr>
                                        )} */}
                </tbody>
              </table>
            </div>
          </div>
        </SummaryCard>

        <SummaryCard className="formContainer">
          <div className="formHeaderContainer">
            <h2 className="formHeading">Documents Section</h2>{" "}
          </div>
          <div className="formInputContainer">
            <Grid container spacing={2}>
              {filteredDocuments?.map((document, index) => {
                const documentType =
                  document?.additionalDetails?.title || document?.documentType?.charAt(0).toUpperCase() + document?.documentType?.slice(1);
                return (
                  <Grid item xs={12} md={6} key={index}>
                    {" "}
                    {/* Two items per row on medium screens and above */}
                    <Grid container spacing={2} alignItems="center">
                      <Grid item xs={9}>
                        <strong>{documentType} </strong>:
                      </Grid>{" "}
                      {/* Label part */}
                      <Grid item xs={3}>
                        <FaFilePdf
                          color="#a10505"
                          style={{ width: "20px", height: "30px" }}
                          onClick={() => getDocumentByFileStoreId(document?.fileStoreId, setIsPreviewLoading)}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                );
              })}
            </Grid>
          </div>
        </SummaryCard>

        {/* Fee Information */}
        <SummaryCard className="formContainer">
          <div className="formHeaderContainer">
            <h2 className="formHeading">Fee Details (Step-1)</h2>
          </div>
          <div className="formInputContainer" style={{ display: "flex", justifyContent: "center" }}>
            <div style={{ width: "100%" }}>
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <tbody>
                  <tr>
                    <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                      <b>Plot Type:</b>
                    </td>
                    <td style={{ width: "50%", padding: "8px" }}>{feeDetail?.mapRate?.name}</td>
                  </tr>
                  <tr>
                    <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                      <b>Fee on Plot:</b>
                    </td>
                    <td style={{ width: "50%", padding: "8px" }}>{feeDetail?.mapRate?.price}</td>
                  </tr>

                  {paymentHead?.map((payment, index) => (
                    <tr key={index}>
                      <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                        <b>{payment?.feeType}:</b>
                      </td>
                      <td style={{ width: "50%", padding: "8px" }}>{payment?.amount}</td>
                    </tr>
                  ))}
                  <tr>
                    <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                      <b>Total Fee:</b>
                    </td>
                    <td style={{ width: "50%", padding: "8px", fontWeight: "bolder" }}>{feeDetail?.estimateAmount}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </SummaryCard>
        {formData?.edcrNumber && (
          <div className="formContainer">
            <div className="formHeaderContainer">
              <h2 className="formHeading">{t("Drawing")}</h2>
            </div>
          </div>
        )}
        {formData?.edcrNumber && (
          <SummaryCard className="formContainer">
            <div className="formInputContainer" style={{ display: "flex", justifyContent: "center" }}>
              <div style={{ width: "100%" }}>
                <table style={{ width: "100%", borderCollapse: "collapse", padding: "2rem" }}>
                  <Grid item xs={12} md={6}>
                    {" "}
                    {/* Two items per row on medium screens and above */}
                    <Grid container spacing={2} style={{ padding: "1rem" }}>
                      <Grid item xs={6}>
                        <strong>{"Drawing Pdf"} </strong>:
                      </Grid>{" "}
                      {/* Label part */}
                      <Grid item xs={6}>
                        <FaFilePdf
                          color="#a10505"
                          style={{ width: "20px", height: "30px" }}
                          onClick={() => window.open(formData?.updatedDxfFile, "_blank")}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <strong>{"Plan Report"} </strong>:
                      </Grid>{" "}
                      {/* Label part */}
                      <Grid item xs={6}>
                        <FaFilePdf
                          color="#a10505"
                          style={{ width: "20px", height: "30px" }}
                          onClick={() => window.open(formData?.planReport, "_blank")}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <strong>{"DXF File"} </strong>:
                      </Grid>{" "}
                      {/* Label part */}
                      <Grid item xs={6}>
                        <FaFilePdf
                          color="#a10505"
                          style={{ width: "20px", height: "30px" }}
                          onClick={() => window.open(formData?.dxfFile, "_blank")}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </table>
              </div>
            </div>
          </SummaryCard>
        )}
        {/* Informational content */}
        {/* <InfoBox>
                    This project is based on the inputs and documents provided by the Licensed Technical Person (LTP). It is entirely reliant on the trust and verification conducted by the LTP.
                </InfoBox>  */}
        {showDeclaration && (
          <div className="formContainer">
            <FormControlLabel
              style={{ padding: "10px 15px" }}
              control={<Checkbox name="declaration" checked={declarationChecked} onChange={handleDeclarationChange} />}
              label={
                <span>
                  I, as a Licensed Technical Professional (LTP), certify that all the details provided in the application form has been checked and
                  verified against the Building Bylaws and Rules applicable in the State of Uttar Pradesh. I also understand that approval of this
                  application shall be based on Trust and Simplified Process, hence I take total ownership of information and documents submitted with
                  this application.{" "}
                </span>
              }
            />
          </div>
        )}
      </div>
    </div>
  );
});
export default MapSubmissionSummary;
